
type RunOnceAtIntervalParams<T> = {
  interval: number
  callback: (event: T) => void
  onFinish?: (event: T) => void
};

export default function runOnceAtIntervalTime<T>({ 
  interval, 
  callback, 
  onFinish,
}: RunOnceAtIntervalParams<T>): (currentEvent: T) => void {
  
  let isNeedRunCallback: boolean = false
  let isRunCallbackBlocked: boolean = false
  let event: T

  const runCallback = (): void => {
    if (isNeedRunCallback) {
      callback(event)
      setTimeout(runCallback, interval)
    } else {
      if (onFinish) {
        onFinish(event)
      }
      isRunCallbackBlocked = false
    }
    isNeedRunCallback = false
  };

  return (currentEvent: T): void => {
    event = currentEvent

    if (isRunCallbackBlocked) {
      isNeedRunCallback = true
    } else {
      isRunCallbackBlocked = true
      callback(event)
      setTimeout(runCallback, interval)
    }
  }
}
